<template>
  <div class="resources-page">
    <div class="header">
      {{ $t('resources.header') }}
    </div>
    <div class="description">
      {{ $t('resources.description') }}
    </div>
    <div class="body">
      <div class="category">
        <div class="cat-header">
          {{ $t('resources.body.category-1.header') }}
        </div>
        <ul class="cat-content">
          <li>
            <a
              href="https://collegereadiness.collegeboard.org/sat"
              target="_blank"
              >{{ $t('resources.body.category-1.SATWebsite') }}</a
            >
          </li>
          <li>
            <a
              href="http://www.act.org/content/act/en/students-and-parents.html"
              target="_blank"
              >{{ $t('resources.body.category-1.ACTWebsite') }}</a
            >
          </li>
          <li>
            <a
              href="https://collegereadiness.collegeboard.org/sat-subject-tests"
              target="_blank"
              >{{ $t('resources.body.category-1.SATSubjectTests') }}</a
            >
          </li>
          <li>
            <a
              href="https://bigfuture.collegeboard.org/find-colleges"
              target="_blank"
              >{{ $t('resources.body.category-1.collegeSearchEngine') }}</a
            >
          </li>
          <li>
            <a href="http://www.commonapp.org/" target="_blank">{{
              $t('resources.body.category-1.commonApp')
            }}</a>
          </li>
          <li>
            <a href="https://fafsa.ed.gov/" target="_blank">{{
              $t('resources.body.category-1.fafsa')
            }}</a>
          </li>
          <li>
            <a
              href="https://student.collegeboard.org/css-financial-aid-profile"
              target="_blank"
              >{{ $t('resources.body.category-1.cssFinancialAidProfile') }}</a
            >
          </li>
          <li>
            <a href="https://www.khanacademy.org/sat" target="_blank">{{
              $t('resources.body.category-1.SATPracticeQuestions')
            }}</a>
          </li>
        </ul>
      </div>
      <div class="category">
        <div class="cat-header">
          {{ $t('resources.body.category-2.header') }}
        </div>
        <ul class="cat-content">
          <li>
            <a href="https://www.khanacademy.org/math/" target="_blank">{{
              $t('resources.body.category-2.khanAcademy')
            }}</a>
          </li>
          <li>
            <a href="https://www.wolframalpha.com/" target="_blank">{{
              $t('resources.body.category-2.wolfRamAlpha')
            }}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({ user: state => state.user.user }),
  },
}
</script>

<style lang="scss" scoped>
.resources-page {
  border-radius: 8px;
  padding: 40px 20px;
  margin: 40px 20px;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @include breakpoint-above('large') {
    margin: 40px;
    padding: 40px;
  }
}

.header {
  color: $c-soft-black;
  font-size: 24px;
  font-weight: 500;
}

.description {
  text-align: left;
  margin: 10px 0 35px;
  color: #77778b;
  font-size: 14px;
}

.body {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 16px;
}

.category {
  padding-bottom: 10px;
}

.cat-header {
  text-align: left;
  font-size: 18px;
  font-weight: 500;
  padding-bottom: 10px;
}

ul {
  text-align: left;
}

li {
  padding-bottom: 10px;
}

html.is-rtl {
  .description {
    text-align: right;
  }

  .cat-header {
    text-align: right;
  }

  ul {
    text-align: right;
  }
}
</style>
